// Modal.js

import React from "react";

const Modal = ({ isOpen, onClose, children }) => {
	if (!isOpen) return null;

	return (
		<div
			style={{
				position: "fixed",
				top: 0,
				left: 0,
				width: "100%",
				height: "100%",
				background: "rgba(0, 0, 0, 0.5)",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
                zIndex: 999
			}}
		>
            
			<div
				style={{
					background: "white",
					margin: "auto",
					padding: "1%",
					border: "2px solid #000",
					borderRadius: "10px",
					boxShadow: "2px solid black",
                    width: "90%",
                    maxHeight: "90%",
                    overflowY: "scroll"
				}}
			>
            <div onClick={onClose} style={{ 
    position: "absolute",
    border: "3px solid #000000",
    padding: "0px 8px",
    borderRadius: "50%",
    float: "right",
    fontWeight: "600",
    background: "#FFF",
    marginTop: "-34px",
    right: 0,
    marginRight: "4.5%",
    fontSize: "20px",
cursor:"pointer" }}>X</div>
				{children}
			</div>
		</div>
	);
};

export default Modal;
